import React from 'react'
import Textfield from "Components/UI/Form/Textfield";

//MUI
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import { systemStatusOptions } from "utils/options/systemStatusOptions";
const status = [
    { label: "Utkast", value: 0 },
    { label: "Aktiv", value: 1 },
    { label: "Borttagen", value: 2 },
];

export default function OptionFormSystem({ formData, handleInputChange }) {
   
    return (
        <>
            <Grid container spacing={3} sx={{ marginTop: "10px" }}>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        label="Kontrollstatus"
                        value={formData.ParseStatus}
                        disabled
                        size="small"
                        color="primary"
                        fullWidth
                        margin="dense"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        label="Kontrollmeddelande"
                        value={formData.ParseMessage}
                        disabled
                        size="small"
                        color="primary"
                        fullWidth
                        margin="dense"
                    />
                </Grid>


                <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                            name="SystemStatus"
                            value={formData.SystemStatus}
                            onChange={(e) =>
                                handleInputChange("SystemStatus", e.target.value)
                            }
                            label="Status"
                            size="small"
                        >
                            {systemStatusOptions.map((option) => (
                                <MenuItem key={option.Value} value={option.Value}>
                                    {option.Name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Textfield
                        disabled
                        name="Skapad"
                        label="Skapad"
                        value={formData.CreateTime}
                        format="YYYY-MM-DD"
                        slotProps={{
                            textField: { size: "small", fullWidth: true, margin: "dense" },
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
}
